function promiseFetchDataAuth(url, method, data) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    }

    const token = localStorage.getItem('access_token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const init = {
      method: method ? method : 'GET',
      headers,
    }

    if(data) init.body = typeof data === 'object' ? JSON.stringify(data) : data;
    
    fetch(url, init)
    .catch(err => {
      console.error(err);
      reject(err);
    })
    .then(res => res.json())
    .catch(err => {
      console.error(err);
      reject(err);
    })
    .then(json => {
      if (
        (json.code && json.code.match(/ok/i)) ||
        (json.result && json.result.match(/ok/i))
      ) 
      {
        resolve(json.data || json);
      }

      reject(json.error || json.message);
    })
    .catch(err => {
      reject(err);
    })
  })
}

function promiseFetchDownloadAuth(url, method, data, filename) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    }

    const token = localStorage.getItem('access_token');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const init = {
      method: method ? method : 'GET',
      headers,
    }

    if(data) init.body = typeof data === 'object' ? JSON.stringify(data) : data;
    
    fetch(url, init)
    .catch(err => {
      console.error(err);
      reject(err);
    })
    .then(res => res.blob())
    .catch(err => {
      console.error(err);
      reject(err);
    })
    .then(blob => {
      var file = window.URL.createObjectURL(blob);
      // window.location.assign(file);

      const a = document.createElement('a');
      a.href = file;
      a.download = filename;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();    
      a.remove();  //afterwards we remove the element again    

      resolve();
    })
    .catch(err => {
      reject(err);
    })
  })
}

var _delayTasks = {};

function delaySave(url, method, data, delay = 1250, name) {
  if (name && _delayTasks[name]) {
    clearTimeout(_delayTasks[name]);
    delete _delayTasks[name];
  }
  // console.info('Tasks', _delayTasks);

  return new Promise((resolve, reject) => {
    const _task = setTimeout(() => {
      promiseFetchDataAuth(url, method, data)
        .then((value) => resolve(value))
        .catch((error) => reject(error));

        if (name && _delayTasks[name]) delete _delayTasks[name];
    }, delay);

    if (name) _delayTasks[name] = _task;
  });
}

module.exports = {
  delaySave,
  promiseFetchDataAuth,
  promiseFetchDownloadAuth,
}